export const matches = [
  {
    id: 'm-1001',
    leagueId: 'nba',
    leagueName: 'NBA',
    homeTeamId: 'nba-lakers',
    awayTeamId: 'nba-warriors',
    homeScore: 82,
    awayScore: 78,
    status: 'live',
    date: '10月12日',
    time: '10:30',
    stage: '常规赛 第 12 轮',
    venue: 'Crypto.com 竞技场',
    progress: '第三节 06:24',
    hot: 9860,
    quarterScores: [
      { quarter: 'Q1', home: 28, away: 24 },
      { quarter: 'Q2', home: 30, away: 27 },
      { quarter: 'Q3', home: 24, away: 27 },
      { quarter: 'Q4', home: 0, away: 0 },
    ],
    stats: [
      { label: '投篮命中率', home: 48, away: 45, unit: '%' },
      { label: '三分命中数', home: 11, away: 13, unit: '个' },
      { label: '篮板', home: 34, away: 31, unit: '个' },
      { label: '助攻', home: 22, away: 20, unit: '次' },
      { label: '抢断', home: 7, away: 5, unit: '次' },
      { label: '盖帽', home: 4, away: 3, unit: '次' },
      { label: '失误', home: 9, away: 12, unit: '次' },
    ],
    events: [
      { time: '10:12', quarter: 'Q1', team: 'home', player: '控球后卫 3 号', type: '三分命中', score: '3-0', desc: '弧顶接球果断出手，空心入网为球队首开纪录。' },
      { time: '10:38', quarter: 'Q1', team: 'away', player: '得分后卫 11 号', type: '快攻上篮', score: '5-6', desc: '抢断后一条龙快攻，双手上篮得手。' },
      { time: '11:05', quarter: 'Q2', team: 'home', player: '中锋 15 号', type: '篮下强攻', score: '24-19', desc: '低位背身单打，转身勾手命中并造成犯规。' },
      { time: '11:26', quarter: 'Q2', team: 'away', player: '小前锋 7 号', type: '三分命中', score: '33-31', desc: '借掩护后底角三分稳稳落袋，将分差缩小。' },
      { time: '11:48', quarter: 'Q3', team: 'home', player: '控球后卫 3 号', type: '助攻', score: '78-74', desc: '突破分球，助攻队友空切上篮打成 2+1。' },
    ],
  },
  {
    id: 'm-1002',
    leagueId: 'nba',
    leagueName: 'NBA',
    homeTeamId: 'nba-celtics',
    awayTeamId: 'nba-nuggets',
    homeScore: 118,
    awayScore: 109,
    status: 'finished',
    date: '10月11日',
    time: '09:00',
    stage: '常规赛 第 11 轮',
    venue: 'TD 花园球馆',
    progress: '已完赛',
    hot: 8720,
    quarterScores: [
      { quarter: 'Q1', home: 32, away: 26 },
      { quarter: 'Q2', home: 28, away: 30 },
      { quarter: 'Q3', home: 31, away: 25 },
      { quarter: 'Q4', home: 27, away: 28 },
    ],
    stats: [
      { label: '投篮命中率', home: 51, away: 46, unit: '%' },
      { label: '三分命中数', home: 18, away: 12, unit: '个' },
      { label: '篮板', home: 46, away: 44, unit: '个' },
      { label: '助攻', home: 30, away: 24, unit: '次' },
      { label: '抢断', home: 8, away: 6, unit: '次' },
      { label: '盖帽', home: 6, away: 5, unit: '次' },
      { label: '失误', home: 11, away: 15, unit: '次' },
    ],
    events: [
      { time: '09:22', quarter: 'Q1', team: 'home', player: '小前锋 0 号', type: '三分命中', score: '9-4', desc: '连续两记干拔三分，主场球迷瞬间沸腾。' },
      { time: '09:55', quarter: 'Q2', team: 'away', player: '中锋 15 号', type: '篮下得分', score: '38-40', desc: '高位策应后顺下暴扣，帮助球队反超比分。' },
      { time: '10:31', quarter: 'Q3', team: 'home', player: '得分后卫 4 号', type: '抢断快攻', score: '86-71', desc: '前场抢断后单臂战斧劈扣，点燃全场。' },
      { time: '11:12', quarter: 'Q4', team: 'away', player: '控球后卫 27 号', type: '三分命中', score: '112-106', desc: '压哨超远三分命中，一度将分差缩小到 6 分。' },
      { time: '11:40', quarter: 'Q4', team: 'home', player: '小前锋 0 号', type: '罚球', score: '118-109', desc: '两罚全中锁定胜局。' },
    ],
  },
  {
    id: 'm-1003',
    leagueId: 'nba',
    leagueName: 'NBA',
    homeTeamId: 'nba-bucks',
    awayTeamId: 'nba-suns',
    homeScore: 121,
    awayScore: 117,
    status: 'finished',
    date: '10月11日',
    time: '11:30',
    stage: '常规赛 第 11 轮',
    venue: '论坛球馆',
    progress: '已完赛',
    hot: 7640,
    quarterScores: [
      { quarter: 'Q1', home: 30, away: 28 },
      { quarter: 'Q2', home: 29, away: 33 },
      { quarter: 'Q3', home: 34, away: 27 },
      { quarter: 'Q4', home: 28, away: 29 },
    ],
    stats: [
      { label: '投篮命中率', home: 49, away: 48, unit: '%' },
      { label: '三分命中数', home: 14, away: 16, unit: '个' },
      { label: '篮板', home: 52, away: 41, unit: '个' },
      { label: '助攻', home: 26, away: 28, unit: '次' },
      { label: '抢断', home: 6, away: 9, unit: '次' },
      { label: '盖帽', home: 7, away: 3, unit: '次' },
      { label: '失误', home: 13, away: 10, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1004',
    leagueId: 'nba',
    leagueName: 'NBA',
    homeTeamId: 'nba-heat',
    awayTeamId: 'nba-mavericks',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    date: '10月13日',
    time: '08:00',
    stage: '常规赛 第 13 轮',
    venue: '卡塞雅中心',
    progress: '未开始',
    hot: 4210,
    quarterScores: [],
    stats: [],
    events: [],
  },
  {
    id: 'm-1005',
    leagueId: 'cba',
    leagueName: 'CBA',
    homeTeamId: 'cba-liaoning',
    awayTeamId: 'cba-guangdong',
    homeScore: 76,
    awayScore: 71,
    status: 'live',
    date: '10月12日',
    time: '19:35',
    stage: '常规赛 第 8 轮',
    venue: '辽宁体育馆',
    progress: '第三节 03:18',
    hot: 11240,
    quarterScores: [
      { quarter: 'Q1', home: 25, away: 22 },
      { quarter: 'Q2', home: 27, away: 24 },
      { quarter: 'Q3', home: 24, away: 25 },
      { quarter: 'Q4', home: 0, away: 0 },
    ],
    stats: [
      { label: '投篮命中率', home: 47, away: 43, unit: '%' },
      { label: '三分命中数', home: 9, away: 8, unit: '个' },
      { label: '篮板', home: 33, away: 30, unit: '个' },
      { label: '助攻', home: 19, away: 16, unit: '次' },
      { label: '抢断', home: 8, away: 6, unit: '次' },
      { label: '盖帽', home: 3, away: 4, unit: '次' },
      { label: '失误', home: 10, away: 12, unit: '次' },
    ],
    events: [
      { time: '19:38', quarter: 'Q1', team: 'home', player: '中锋 22 号', type: '篮下得分', score: '4-2', desc: '低位要位后转身打板命中。' },
      { time: '20:02', quarter: 'Q1', team: 'away', player: '控球后卫 5 号', type: '三分命中', score: '10-12', desc: '挡拆后急停三分命中，客队反超比分。' },
      { time: '20:41', quarter: 'Q2', team: 'home', player: '小前锋 8 号', type: '快攻扣篮', score: '36-30', desc: '抢断后一条龙暴扣，主场气氛达到顶点。' },
      { time: '21:10', quarter: 'Q3', team: 'away', player: '大前锋 21 号', type: '补篮得分', score: '68-66', desc: '前场篮板补篮命中，紧咬比分。' },
    ],
  },
  {
    id: 'm-1006',
    leagueId: 'cba',
    leagueName: 'CBA',
    homeTeamId: 'cba-zhejiang',
    awayTeamId: 'cba-xinjiang',
    homeScore: 98,
    awayScore: 92,
    status: 'finished',
    date: '10月10日',
    time: '19:35',
    stage: '常规赛 第 7 轮',
    venue: '柯桥体育馆',
    progress: '已完赛',
    hot: 6180,
    quarterScores: [
      { quarter: 'Q1', home: 26, away: 24 },
      { quarter: 'Q2', home: 24, away: 22 },
      { quarter: 'Q3', home: 23, away: 22 },
      { quarter: 'Q4', home: 25, away: 24 },
    ],
    stats: [
      { label: '投篮命中率', home: 46, away: 44, unit: '%' },
      { label: '三分命中数', home: 12, away: 9, unit: '个' },
      { label: '篮板', home: 41, away: 43, unit: '个' },
      { label: '助攻', home: 23, away: 18, unit: '次' },
      { label: '抢断', home: 7, away: 8, unit: '次' },
      { label: '盖帽', home: 4, away: 5, unit: '次' },
      { label: '失误', home: 14, away: 16, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1007',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    homeTeamId: 'euro-real',
    awayTeamId: 'euro-barca',
    homeScore: 89,
    awayScore: 81,
    status: 'finished',
    date: '10月10日',
    time: '03:00',
    stage: '常规赛 第 9 轮',
    venue: 'WiZink 中心',
    progress: '已完赛',
    hot: 5340,
    quarterScores: [
      { quarter: 'Q1', home: 24, away: 20 },
      { quarter: 'Q2', home: 21, away: 19 },
      { quarter: 'Q3', home: 22, away: 21 },
      { quarter: 'Q4', home: 22, away: 21 },
    ],
    stats: [
      { label: '投篮命中率', home: 49, away: 45, unit: '%' },
      { label: '三分命中数', home: 10, away: 9, unit: '个' },
      { label: '篮板', home: 38, away: 34, unit: '个' },
      { label: '助攻', home: 21, away: 17, unit: '次' },
      { label: '抢断', home: 6, away: 7, unit: '次' },
      { label: '盖帽', home: 5, away: 3, unit: '次' },
      { label: '失误', home: 9, away: 13, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1008',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    homeTeamId: 'euro-olympiacos',
    awayTeamId: 'euro-fener',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    date: '10月14日',
    time: '02:30',
    stage: '常规赛 第 10 轮',
    venue: '和平友谊体育馆',
    progress: '未开始',
    hot: 2980,
    quarterScores: [],
    stats: [],
    events: [],
  },
  {
    id: 'm-1009',
    leagueId: 'wnba',
    leagueName: 'WNBA',
    homeTeamId: 'wnba-aces',
    awayTeamId: 'wnba-liberty',
    homeScore: 92,
    awayScore: 85,
    status: 'finished',
    date: '10月09日',
    time: '10:00',
    stage: '总决赛 第三场',
    venue: '米切罗布超竞技场',
    progress: '已完赛',
    hot: 6820,
    quarterScores: [
      { quarter: 'Q1', home: 25, away: 22 },
      { quarter: 'Q2', home: 23, away: 21 },
      { quarter: 'Q3', home: 22, away: 20 },
      { quarter: 'Q4', home: 22, away: 22 },
    ],
    stats: [
      { label: '投篮命中率', home: 47, away: 43, unit: '%' },
      { label: '三分命中数', home: 11, away: 10, unit: '个' },
      { label: '篮板', home: 39, away: 36, unit: '个' },
      { label: '助攻', home: 24, away: 19, unit: '次' },
      { label: '抢断', home: 9, away: 5, unit: '次' },
      { label: '盖帽', home: 6, away: 4, unit: '次' },
      { label: '失误', home: 11, away: 14, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1010',
    leagueId: 'ncaa',
    leagueName: 'NCAA',
    homeTeamId: 'ncaa-uconn',
    awayTeamId: 'ncaa-duke',
    homeScore: 79,
    awayScore: 72,
    status: 'finished',
    date: '10月08日',
    time: '09:30',
    stage: '精英八强赛',
    venue: '甘佩尔馆',
    progress: '已完赛',
    hot: 4560,
    quarterScores: [
      { quarter: 'H1', home: 40, away: 34 },
      { quarter: 'H2', home: 39, away: 38 },
    ],
    stats: [
      { label: '投篮命中率', home: 48, away: 44, unit: '%' },
      { label: '三分命中数', home: 8, away: 7, unit: '个' },
      { label: '篮板', home: 36, away: 32, unit: '个' },
      { label: '助攻', home: 18, away: 15, unit: '次' },
      { label: '抢断', home: 7, away: 6, unit: '次' },
      { label: '盖帽', home: 4, away: 3, unit: '次' },
      { label: '失误', home: 10, away: 12, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1011',
    leagueId: 'fiba',
    leagueName: 'FIBA',
    homeTeamId: 'fiba-usa',
    awayTeamId: 'fiba-serbia',
    homeScore: 101,
    awayScore: 94,
    status: 'finished',
    date: '10月07日',
    time: '20:00',
    stage: '国际邀请赛 决赛',
    venue: '阿布扎比体育馆',
    progress: '已完赛',
    hot: 8140,
    quarterScores: [
      { quarter: 'Q1', home: 27, away: 24 },
      { quarter: 'Q2', home: 26, away: 25 },
      { quarter: 'Q3', home: 25, away: 23 },
      { quarter: 'Q4', home: 23, away: 22 },
    ],
    stats: [
      { label: '投篮命中率', home: 50, away: 47, unit: '%' },
      { label: '三分命中数', home: 15, away: 12, unit: '个' },
      { label: '篮板', home: 40, away: 42, unit: '个' },
      { label: '助攻', home: 27, away: 23, unit: '次' },
      { label: '抢断', home: 8, away: 6, unit: '次' },
      { label: '盖帽', home: 5, away: 4, unit: '次' },
      { label: '失误', home: 12, away: 14, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1012',
    leagueId: 'nba',
    leagueName: 'NBA',
    homeTeamId: 'nba-lakers',
    awayTeamId: 'nba-celtics',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    date: '10月15日',
    time: '10:30',
    stage: '常规赛 第 14 轮',
    venue: 'Crypto.com 竞技场',
    progress: '未开始',
    hot: 12560,
    quarterScores: [],
    stats: [],
    events: [],
  },
  {
    id: 'm-1013',
    leagueId: 'nba',
    leagueName: 'NBA',
    homeTeamId: 'nba-warriors',
    awayTeamId: 'nba-bucks',
    homeScore: 112,
    awayScore: 106,
    status: 'finished',
    date: '10月09日',
    time: '10:00',
    stage: '常规赛 第 10 轮',
    venue: '大通中心',
    progress: '已完赛',
    hot: 5920,
    quarterScores: [
      { quarter: 'Q1', home: 30, away: 26 },
      { quarter: 'Q2', home: 27, away: 28 },
      { quarter: 'Q3', home: 28, away: 25 },
      { quarter: 'Q4', home: 27, away: 27 },
    ],
    stats: [
      { label: '投篮命中率', home: 50, away: 46, unit: '%' },
      { label: '三分命中数', home: 19, away: 13, unit: '个' },
      { label: '篮板', home: 43, away: 47, unit: '个' },
      { label: '助攻', home: 31, away: 22, unit: '次' },
      { label: '抢断', home: 10, away: 7, unit: '次' },
      { label: '盖帽', home: 3, away: 6, unit: '次' },
      { label: '失误', home: 12, away: 15, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1014',
    leagueId: 'cba',
    leagueName: 'CBA',
    homeTeamId: 'cba-guangdong',
    awayTeamId: 'cba-zhejiang',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    date: '10月14日',
    time: '19:35',
    stage: '常规赛 第 9 轮',
    venue: '东莞篮球中心',
    progress: '未开始',
    hot: 5120,
    quarterScores: [],
    stats: [],
    events: [],
  },
  {
    id: 'm-1015',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    homeTeamId: 'euro-barca',
    awayTeamId: 'euro-olympiacos',
    homeScore: 84,
    awayScore: 88,
    status: 'finished',
    date: '10月08日',
    time: '03:00',
    stage: '常规赛 第 8 轮',
    venue: '帕劳布劳格拉纳',
    progress: '已完赛',
    hot: 3980,
    quarterScores: [
      { quarter: 'Q1', home: 22, away: 23 },
      { quarter: 'Q2', home: 20, away: 21 },
      { quarter: 'Q3', home: 21, away: 22 },
      { quarter: 'Q4', home: 21, away: 22 },
    ],
    stats: [
      { label: '投篮命中率', home: 44, away: 47, unit: '%' },
      { label: '三分命中数', home: 9, away: 11, unit: '个' },
      { label: '篮板', home: 35, away: 38, unit: '个' },
      { label: '助攻', home: 16, away: 19, unit: '次' },
      { label: '抢断', home: 5, away: 8, unit: '次' },
      { label: '盖帽', home: 4, away: 5, unit: '次' },
      { label: '失误', home: 14, away: 11, unit: '次' },
    ],
    events: [],
  },
  {
    id: 'm-1016',
    leagueId: 'wnba',
    leagueName: 'WNBA',
    homeTeamId: 'wnba-liberty',
    awayTeamId: 'wnba-aces',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    date: '10月16日',
    time: '10:00',
    stage: '总决赛 第四场',
    venue: '巴克莱中心',
    progress: '未开始',
    hot: 7260,
    quarterScores: [],
    stats: [],
    events: [],
  },
];